@import "../../../globalStyles/commons";

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
